<template>
  <div class="foot-con">
    <div class="foot-left">
      <div class="foot-logo"><img src="@/assets/logo2.png"/></div>
      <div class="foot-title">
        <div class="title">
          <img src="@/assets/tag4.png"/>
          <span>地址：千鹤家园1号楼2403，北京市，朝阳区，中国</span>
        </div>
        <div class="title">
          <img src="@/assets/tag3.png"/>
          <span>邮箱：info@tri-think.cn</span>
        </div>
        <div class="title">
          <img src="@/assets/tag5.png"/>
          <span>Copyright@2018-2025 TRI-THINK All Rights Reserved</span>
        </div>
        <div class="title">
          <img src="@/assets/tag2.png"/>
          <span><a href="https://beian.miit.gov.cn" target="_blank">京ICP备2020042206号-1</a></span>
        </div>
      </div>
    </div>
    <div class="foot-right">
      <img src="@/assets/er.png"/>
      <span>官方公众号</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'FootView',
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>
<style scoped lang="scss">
.foot-con {
  width: 100%;
  height:300px;
  background:#1b1918;
  padding: 66px 250px 70px 250px;
  display: flex;
  justify-content: space-between;
  .foot-left {
    display: flex;
    align-items: center;
    .foot-logo {
      margin-right: 100px;
      img {
        width: 124px;
        height: 124px;
      }
    }
    .foot-title {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title {
        display: flex;
        align-items: center;
        height: 24px;
        margin-bottom: 24px;
        img {
          margin-right: 16px;
          width: 24px;
          height: 24px;
        }
        span {
          font-family:Source Han Sans CN;
          color:#ffffff;
          font-size:18px;
          a {
            color:#ffffff;
            cursor: pointer;
          }
          a:hover {
            color: #0000ee;
          }
        }
      }
    }
  }
  .foot-right {
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      margin-top: 20px;
      width: 101px;
      height: 101px;
    }
    span {
      opacity:60%;
      font-family:Source Han Sans CN;
      color:#ffffff;
      font-size:16px;
      margin-top: 16px;
    }
  }
}
</style>
